import { render, staticRenderFns } from "./OrganizationSales.vue?vue&type=template&id=045aa15a"
import script from "./OrganizationSales.vue?vue&type=script&lang=js"
export * from "./OrganizationSales.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSales.vue?vue&type=style&index=0&id=045aa15a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports